import { useEffect } from 'react';

import { SimpleAlert } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import { useStatusForm } from '@/components/form/context';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import appStore from 'stores/app';

function RewardHeading({ item, active, onChangeActive }) {
  const { status } = useStatusForm()

  useEffect(() => {
    appStore.setLayout('heading', true)
    return () => {
      appStore.setLayout('heading', false)
    }
  }, [])

  return <>
    <HeaderContainerForm
      title='Rewards'
      data={{ ...item, createdAt: formatDateTime(item?.created_at), updatedAt: formatDateTime(item?.updated_at) }}
      onCancel={() => history.goBack()}
      className='border-b-0'
    >
      {(status.stepOrderChanged && item.id) && <SimpleAlert variant="warning" className='px-4 py-2'>
        You have unsaved changes
      </SimpleAlert>}
      <ActiveForm active={active} onChangeActive={onChangeActive} />
    </HeaderContainerForm>
  </>
}

export default RewardHeading
